import { render, staticRenderFns } from "./UserProfilePaymentHistoryCard.vue?vue&type=template&id=29bc7a72"
import script from "./UserProfilePaymentHistoryCard.vue?vue&type=script&lang=js"
export * from "./UserProfilePaymentHistoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports